/**
 * Lazy Video - Moon Moon Agency
 * Custom element <mm-lazy-video> : lit la vidéo enfant quand elle approche du viewport, la met en pause quand elle en sort.
 * La vidéo est rendue sans autoplay et avec preload="none" : rien n'est téléchargé avant qu'elle soit visible.
 * Un élément en display: none n'est jamais visible : la vidéo desktop ne se charge pas sur mobile, et inversement.
 * Avec prefers-reduced-motion, la vidéo n'est jamais lancée et l'image d'aperçu reste affichée.
 */
import { prefersReducedMotion } from '@theme/utilities';

class MMLazyVideo extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video || prefersReducedMotion()) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      },
      { rootMargin: '200px 0px', threshold: 0.1 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('mm-lazy-video')) customElements.define('mm-lazy-video', MMLazyVideo);
